import React, { Component } from 'react';
import { TabPane } from 'reactstrap';
import { PayrollHistory } from './grids/PayrollHistory';
import { W2History } from './grids/W2History';
import { MiscDocuments } from './grids/MiscDocuments';

export class PayrollInformation extends Component {
    render() {
        return (<TabPane tabId="4">
            {this.props.apdConsent && <PayrollHistory {...this.props} />}
            {this.props.w2Consent && <W2History {...this.props} />}
            <MiscDocuments {...this.props} />
        </TabPane>);
    }
}